import Step1 from "../assets/images/how-it-works-1.svg";
import Step2 from "../assets/images/how-it-works-2.svg";
import Step3 from "../assets/images/how-it-works-3.svg";
import Step4 from "../assets/images/how-it-works-4.svg";

const HEADING = {
  WELCOME_BACK: "Welcome back!",
  LETS_GET_STARTED: "Let's get started",
};

const HOME_PAGE = {
  buttonLabels: {
    about: "About Us",
    howItWorks: "How it works",
    continueAsGuest: "Continue as guest",
    login: "Login",
    signup: "Sign Up",
    browse: "Browse",
    viewAll: "View all",
    support: "Get Support",
  },
  footer: {
    quickLinks: "Quick Links",
    wanderobe: "©2026 Wanderobe. All Rights Reserved.",
    terms: "Terms & Conditions",
    privacy: "Privacy Policy",
    termsAriaLabel: "Go to Terms & Conditions page",
    privacyAriaLabel: "Go to Privacy Policy page",
    logoAriaLabel: "Go to Landing page",
    logoAltText: "Wanderobe Logo",
    title:
      "Don't just visit the city. Wear it home.",
    instaAriaLabel: "Follow us on Instagram",
    fbAiraLabel: "Follow us on Facebook",
    twitterAriaLabel: "Follow us on Twitter",
    getInTouch: "Get in Touch",
    downloadApp: "Download the app",
    downloadAppLabel:
      "Download the app",
  },
  ariaLabels: {
    goToAbout: "Go to About us page",
    goToHowItWorks: "Go to How it works page",
    goToSupport: "Go to Support page",
    openBag: "Open Bag",
    goToCloset: "Go to Closet page",
    goToMyProfile: "Go to profile",
    goToBrowseMore: "Go to Browse more page",
    login: "Go to Login page",
    signup: "Go to Sign up page",
    navigateToLanding: "Navigate to Landing page",
    search: "Search by designer",
    howItWorks: "Go to How it works section",
    customerSupport: "Go to Customer support form",
    showNavigation: "Show Navigation bar",
    viewProfile: "View profile",
    open_close: "Open/Close Section",
    exploreCollections: "Explore all collections",
    viewAllCollecstions: "View all collections",
    scrollPrevious: "Scroll to previous products",
    scrollNext: "Scroll to next products",
  },
  placeholders: {
    search: "Search by designer",
    logo: "Wanderobe Logo",
  },
  messages: {
    newUser: "New user?",
    createAccount: "Create Your Wanderobe Account",
    joinPrompt:
      "Join to explore the world of designer fashion at your travel destination",
  },
  drawerText: {
    customerSupport: "Customer Support",
    browse:"Browse",
    bag: "Bag",
    myCloset: "Closet",
    profile: "Profile",
  },
};

const SUB_HEADING = {
  LOGIN_TO_CONTINUE_TO_ACCOUNT: "Login to continue to your account",
  CREATE_YOUR_ACCOUNT_BY_ENTERING_EMAIL:
    "Create your account by entering your email",
};

const USER_TYPE = {
  BUYER: "B",
  SELLER: "S",
};
const DEVICE_TYPE = {
  WEB: "web",
};

const INPUT_LABELS = {
  fullName: "Full Name",
  email: "Email",
  password: "Password",
  confirmPassword: "Confirm Password",
  sellerName: "Seller Name",
  brandName: "Brand Name",
  emailAddress: "Email Address",
  newPassword: "New Password",
  businessName: "Business Name",
  website: "Website",
  Appareltype: "Apparel Type",
  Categories: "Categories",
  locationStudio: "Location of Studio/HQ",
  ManufacturLocation: "Manufacturing Location",
  inventoryStorage: "Inventory Storage Location",
  streetAddress: "Street Address",
  city: "City",
  zipCode: "Zip/Postal Code",
  country: "Country",
  instagram: "Instagram",
  other: "Other",
  brandWriteUp: "Brand Write-up",
  productsProcesses: "Products/Processes",
  bio: "Bio",
  favAboutNYC: "Favorite Thing About NYC",
  productName: "Product Name",
  status: "Status",
  collections: "Collections",
  tags: "Tags",
  description: "Description",
  priceinUSD: "Price (in USD)",
  totalQuantity: "Total Quantity",
  selectSize: "Select Size",
  selectColor: "Select Color",
  varientQuantity: "Quantity"
};

const BUTTON_LABELS = {
  LOGIN: "Login",
  SIGN_UP_GOOGLE: "Sign up with Google",
  SIGN_UP_FACEBOOK: "Sign up with Facebook",
  SIGN_UP: "Sign Up",
  FORGOT_PASSWORD: "Forgot Password",
  REMEMBER_ME: "Remember me",
  CONTINUE: "Continue",
  CREATE_ACCOUNT: "Create Account",
  SAVE_AND_CONTINUE: "Save & Continue",
  SEND_REQUEST: "Send Request",
  SUBMIT: "Submit",
  REQUEST_NEW_REQUEST_LINK: "Request a new request link",
  CONTACT_SUPPORT: "Contact Support",
  BACK_TO_LOGIN: "Back to login",
  ADD_NEW_PRODUCT: "+ Add New product",
  SAVE_PRODUCT: "Save product",
  CONNECT_STRIPE: "Connect with Stripe",
  DELETE_PRODUCT: "Delete product",
  CONNECT_SHOPIFY: "Connect Shopify",
};

const ADD_VARIENTS_CONSTANTS = {
selectSize: "Select Size",
selectColor: "Select Color",
selectQuantity: "Select Quantity",
maxImage: "Maximum images: 6",
imageSupport: "Supported format: .png, .jpg",
errorMessageTotalQuantity: "Total quantity must match the sum of all variant quantities"
}


const FAQ_CONSTANTS = {
  HELP_TITLE: "HELP & SUPPORT",
  SUPPORT_TEXT:
    "From setting up your account to growing your business, our dedicated support team is here to help.",
  BUTTON_LABEL: "Contact Support",
  FAQ_TITLE: "FAQ’s",
  SECTION_TITLE: "Here to Support You Every Step of the Way",
  accordions: [
    {
      id: "panel1",
      title: "How do I sell my clothes through Wanderobe?",
      content:
        "Apply through the Wanderobe website. We’ll review your portfolio and reach out if we think your brand is a good fit for our audience. Approved Sellers will be invited to set up their profiles through the Platform."
    },
    {
      id: "panel2",
      title: "Who are Wanderobe's buyers?",
      content:
        "Our customers are stylish explorers and frequent travelers who value quality, craftsmanship, and cultural authenticity.",
    },
    {
      id: "panel3",
      title: "What are the benefits of joining Wanderobe?",
      content:
        "Wanderobe is built to support and uplift emerging, independent designers. As a partner designer, you’ll gain access to a highly targeted audience, tools to showcase your collections, and the opportunity to participate in exclusive promotional events.",
    },
    {
      id: "panel4",
      title: "How much does it cost to join Wanderobe?",
      content:
        "There are no fees to join Wanderobe as a Seller. We charge a small commission on each sale made through the platform.",
    },
    {
      id: "panel5",
      title: "How does Wanderobe handle payments?",
      content:
        "We process all payments securely and transfer funds to your account on a regular schedule. You’ll also have access to detailed sales analytics.",
    },
    {
      id: "panel6",
      title: "Can I set my own return policy?",
      content:
        "Wanderobe has a standard return policy built into the service model. We give customers 2 days to try the items (using their hotel room as the fitting room) and decide what they want to keep. Any items kept past the trial period, or worn outside of the hotel room, are charged as a non-refundable purchase. Any items they elect not to keep after the 2 day trial will be returned to you in as-new condition.",
    },
    {
      id: "panel7",
      title: "How do I fulfill orders through Wanderobe?",
      content:
        "Sellers are notified in realtime as orders are placed and will be expected to promptly fulfill the orders. All orders are drop shipped directly to Wanderobe HQ in Brooklyn, New York for processing. There is also the option of a consignment model, in which some inventory is housed at Wanderobe HQ to facilitate seamless, on-demand processing. Wanderobe takes a smaller commision from designers selling through the consignment model.",
    },
    {
      id: "panel8",
      title: "How do I set up my inventory?",
      content:
        "Wanderobe's seller platform includes user-friendly inventory management. You will be required to invest a bit of time upfront to upload your inventory, which will update dynamically as orders are processed.  ",
    },
  ],
};
const FAQ_CONSTANTS_MAIN = {
  maintitle:"How can we assist you?",
  title:"Getting started",
  subtitle:"Step-by-step instruction",
  boxplaceholder:"Search topics",
  FAQtitle:"FAQ’s",
  FAQsubtitle:"Get quick answers to common questions.",
  contactTitle:"Contact Us",
  contactPhone:"Phone",
  contactEmail:"Email",
  contactpara:"Available Monday to Friday 8:00 AM to 9:00 PM EST.",
};

const HOW_IT_WORKS_STEP = [
  {
    title: "Apply to Sell with Wanderobe",
    description: "Submit information about your brand and business to apply for Wanderobe Seller status.",
    url: Step1,
  },
  {
    title: "Create Your Designer Page",
    description:
      "Once approved, you'll be invited to the Seller platform to set up your Designer Profile and integrate your inventory.",
    url: Step2,
  },
  {
    title: "Set Up Your Dashboard",
    description: "Choose which styles you want to activate and set your prices. Easily manage all your orders in one place.",
    url: Step3,
  },
  {
    title: "Create, We Handle the Rest",
    description:
      "Fulfill orders effortlessly while Wanderobe handles logistics and returns, so you can focus on creating.",
    url: Step4,
  },
];

const HOW_IT_WORKS_SECTION_STEPS = [
  {
    number: "01",
    title: "Apply to Sell",
    description: "Tell us about your brand and apply to join our platform of emerging and independent designers.",
  },
  {
    number: "02",
    title: "Create Your Designer Page",
    description: "Once approved, set up your profile and either integrate your Shopify store or manually upload your inventory.",
  },
  {
    number: "03",
    title: "Set Up Your Dashboard",
    description: "Select which styles to activate, set your prices, and manage orders — all in one place.",
  },
  {
    number: "04",
    title: "Create, We Handle the Rest",
    description: "Wanderobe takes care of white-glove logistics and hotel-based returns, so you can focus on doing what you do best — designing.",
  },
];

const INVENTORY_PAYMENT_SETUP = [
  {
    step: "01",
    title: "Inventory Setup",
    description: "Add product details, images, pricing, variants, and control visibility to keep your store organized and attractive.",
  },
  {
    step: "02",
    title: "Convenient Fulfillment",
    description: "Drop-ship, dedicate on-hand inventory, or arrange same-day pickup with Wanderobe personnel.",
  },
  {
    step: "03",
    title: "Streamlined Payments",
    description: "Secure transactions, monthly payouts, and simple invoice management with Stripe.",
  },
  {
    step: "04",
    title: "Painless Returns",
    description: "Wanderobe facilitates any returns after guests’ 2-day trial period.",
  },
];
// WANDEROBE_CONTENT.js
const WANDEROBE_CONTENT = {
  titlemain:"Get Started",
  title: "Empowering Designers.",
  title2Prefix :"Inspiring",
  title2Highlight : "Travelers.",
  subtitle: "About",
  description1:
    "Wanderobe is a one-of-a-kind platform connecting independent and emerging fashion designers with travelers seeking curated wardrobe experiences in destination cities.",
  description2:
    "We bridge the gap between your designs and discerning customers, providing:",
  list : [
      { title: "Seamless Logistics", text: "We manage order processing, delivery, and returns so you can focus on your craft." },
      { title: "Increased Exposure", text: "Showcase your unique designs to a global audience of travelers." },
      { title: "Sales Support", text: "Access a streamlined system for showcasing and selling your creations." }
    ],
    
  description3:
    "As a seller, you'll gain access to a customer base of travelers eager to discover unique, high-quality fashion while Wanderobe ensures a premium customer experience.",
  imgAlt: "Designer at work",
  goback:"Go back",
  altLogo:"Logo",
  altLine:"Horizontal Line",
  buttonLabel:"Join Wanderobe Today",
};

const SOCIALMEDIA_URL = {
  facebook: " https://www.facebook.com/profile.php?id=61575244167877",
  instagram: "https://www.instagram.com/wanderobe.co/",
  twitter: "https://www.x.com/",
  appleStore: {
    alt: "App Store",
    url: "https://apps.apple.com/us/app/wanderobe/id6740470599",
    ariaLabel: "Download from App Store",
  },
  playStore: {
    alt: "Google Play",
    url: "https://play.google.com/store/apps/details?id=com.wanderobe_mobile",
    ariaLabel: "Download from Google Play",
  },
};
const ORDER_CARD_CONSTANTS = {
  totalProducts: "Total products",
  newOrders: "New orders",
  activeOrders: "Active orders",
  completedOrders: "Completed orders",
  cancelledOrders: "Cancelled orders",
};
const LOW_IN_STOCK_CONSTANTS = {
  sectionTitle: "Low in stocks",
  lowInStockLabel: "LOW IN STOCKS",
  stockLeft: "left in stock",
};
const INVENTORY_SECTION = {
 title : "Inventory action required"
};
const FAVOURITE_ITEM = {
  title : "Favorited Items",
  button : "View all products",
};

const ORDER_MANAGEMENT_LABELS = {
  ORDER_NO: "Order no.",
  ORDER_PLACED_AT: "Order placed at",
  SHIP_BY: "Ship by",
  TOTAL_ITEMS: "Total Items",
  PENDING_AMOUNT: "Pending amount",
  RETURNED_ITEMS: "Returned items",
  PRODUCT_NAME: "Product name",
  CANCELLATION_DATE:"Cancellation Date",
  SIZE_COLOR: "Size/Color",
  KEPT_ITEMS: "Kept items",
  PRICE: "Price",
  QUANTITY: "Qty.",
  TOTAL_AMOUNT: "Total amount",
  TABS : ["New", "Active", "Returned", "Completed", "Cancelled"],
  ACTION: "Action",
  STATUS: "Status",
  TABS_MAPPING : {
    New: "new",
    Active: "active",
    Returned: "returned",
    Completed: "completed",
    Cancelled: "cancelled",
  },
};

const TABLE_CONSTANTS = {
  SHOWING :"Showing",
  OF: "of",
}

const PAGE_PER_COUNT_OPTIONS = [10, 25, 50, 100];

export {
  HEADING,
  SUB_HEADING,
  BUTTON_LABELS,
  INPUT_LABELS,
  FAQ_CONSTANTS,
  USER_TYPE,
  DEVICE_TYPE,
  INVENTORY_PAYMENT_SETUP,
  WANDEROBE_CONTENT,
  HOW_IT_WORKS_STEP,
  HOW_IT_WORKS_SECTION_STEPS,
  HOME_PAGE,
  SOCIALMEDIA_URL,
  ADD_VARIENTS_CONSTANTS ,
  ORDER_CARD_CONSTANTS,
  LOW_IN_STOCK_CONSTANTS,
  FAQ_CONSTANTS_MAIN,
  INVENTORY_SECTION,
  FAVOURITE_ITEM,
  ORDER_MANAGEMENT_LABELS,
  TABLE_CONSTANTS,
  PAGE_PER_COUNT_OPTIONS
};
